module.exports = __webpack_public_path__ + "img/gr.grd0a42f6.svg";